import gql from 'graphql-tag'

export const submitHelpRequestMutation = gql`
  mutation SubmitHelpRequestMutation($data: SubmitHelpRequestInput!) {
    submitHelpRequest(data: $data)
  }
`
